<template>
    <ac-modal :title="'Add existing physician'" ref="modal">
        <template>
            <div v-if="widgetReady">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>NPI</label>
                            <small><span class="redText">required </span></small>
                            <input class="form-control" type="text" v-model="vm.npiToCloneFrom">
                        </div>
                    </div>
                </div>
                <div>
                    <shared-settings :parent-entity-id="vm.parentEntityId" :data-model="vm" ref="settings">

                    </shared-settings>
                </div>
            </div>
        </template>
        <template slot="buttons">
            <ac-button class="btn-sm btn-red" :action="cancel">CANCEL</ac-button>
            <ac-button class="btn-sm btn-green" :action="clonePhysician">ADD PHYSICIAN TO THIS LOCATION</ac-button>
        </template>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import SharedSettings from "./SharedSettings.vue";

    export default {
        name: "PhysicianCloningModal",
        components: {SharedSettings},
        data() {
            return {
                vm: {
                    parentEntityId: 0,
                    npiToCloneFrom: 0,
                    controlsPlans: false,
                    receivesPayment: false,
                    controlsInvoice: false,
                    controlsLineItems: false
                },
                widgetReady: false
            }
        },
        methods: {
            showModal(parentEntityId) {
                this.vm.parentEntityId = parentEntityId;
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            cancel() {
                this.$refs.modal.close();
            },
            async clonePhysician() {
                let settings = this.$refs.settings.getSettings();
                let data = {...this.vm, ...settings};
                let result = await api.post('ProviderEntityCreation', 'ClonePhysician', data);
                if (result) {
                    this.$store.dispatch('myProviders/LOAD_MY_PROVIDERS', this.vm.parentEntityId);
                    this.$bus.$emit(this.$AcEvents.NEW_PROVIDER, data);
                    this.$refs.modal.close();
                }
            }
        }
    }
</script>

<style scoped>

</style>